<script setup>
import { onMounted, inject, watch, ref } from 'vue'
import API from '@/js/api.js'

const emit = defineEmits(['close'])
const props = defineProps(['active'])
const data = ref(null)
const isLoading = ref(false)
const api = inject('api')

const getData = async () => {
  const qs = new URLSearchParams(window.location.search)
  isLoading.value = true

  try {
    data.value = await API.get(
      api.index + '?' + qs + '&location=' + props.active._id
    )
  } finally {
    isLoading.value = false
  }
}

onMounted(() => {
  getData()
})

watch(
  () => props.active,
  () => {
    if (props.active) getData()
  }
)
</script>

<template>
  <header>
    <div class="has-text-right">
      <button
        type="button"
        class="button is-black is-small"
        @click="emit('close')"
      >
        <b-icon icon="close"></b-icon>
      </button>
    </div>

    <p class="is-size-7">
      <b>{{ props.active.name }}</b>
    </p>
    <p>{{ props.active.address }}</p>
  </header>

  <main>
    <b-loading :is-full-page="false" v-model="isLoading" />
    <div class="grid" v-if="data" v-html="data.html" />
  </main>
</template>
